module.exports = __webpack_public_path__ + "static/back2-cecaafcb0e315db1ad026a0ba31db1fa.jpg";